<template>
  <el-container>
    <el-header>
      <Navbar
        :needUpdate.sync="needUpdate"
        :needRecharge.sync="needRecharge"
        :dialogLoginVisible.sync="loginFormShow"
      >
      </Navbar>
    </el-header>
    <el-container class="main_cont">
      <NavbarLeft active_idx="/HDrestoration"></NavbarLeft>
      <el-main style="height: 100%; padding: 0">
        <el-container style="height: 100%">
          <el-main
            style="
              background-color: #0b0b1f;
              padding: 14px 18px;
              position: relative;
              display: flex;
              overflow-y: hidden;
            "
          >
            <div style="width: 50%; padding-right: 9px; position: relative">
              <div
                ref="replace_left"
                style="
                  background-color: #111225;
                  border-radius: 14px;
                  margin-top: 20px;
                  padding: 20px;
                  box-sizing: border-box;
                  height: calc(100% - 25px);
                  margin-bottom: 26px;
                  overflow-y: auto;
                  overflow-x: hidden;
                  padding-bottom: 60px;
                "
              >
                <div style="margin-bottom: 20px">
                  <span style="color: #ef4545">*</span> 上传原图
                  <span style="font-size: 13px; color: gray">
                    （图片格式：JPG、JPEG、PNG、BMP等常见格式，建议使用JPG格式。
                    图片大小及分辨率：最大 5 MB; 输入图片尺寸 width 满足 [50, 2128], height 满足 [50, 4046]。
                    图片分辨率小于720*1280的，结果图分辨率会*2，分辨率大于720*1280的，分辨率不变。）
                  </span>
                </div>
                <div
                  class="img_cont img_cont1"
                  :style="{ height: lheight + 'px', width: lwidth + 'px' }"
                >
                  <el-upload
                    class="upload-demo img_cont1"
                    :auto-upload="false"
                    drag
                    action=""
                    accept=".jpg, .png ,.jpeg,.bmp"
                    :before-upload="checkLogin"
                    :on-change="getFile"
                    multiple
                    :show-file-list="false"
                    style="margin: 0 auto; background-color: rgb(17, 18, 37)"
                    :style="{ height: lheight + 'px', width: lwidth + 'px' }"
                    v-if="!proofImage"
                    ref="theupload"
                  >
                    <div
                      style="
                        width: 100%;
                        height: 100%;
                        position: relative;
                        justify-content: center;
                        align-items: center;
                      "
                      :style="{ height: 180 + 'px', width: 360 + 'px' }"
                      class="tool-main-cont d-flex"
                      v-if="!proofImage"
                      fit="contain"
                    >
                      <div>
                        <el-image
                          style="width: 120px; height: 120px; cursor: pointer"
                          :src="require('../assets/img/textform/pic.png')"
                          fit="contain"
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <div style="color: #cacad4">
                          将图片拖至此处，或
                          <span style="color: #006fff">点击上传</span>
                        </div>
                      </div>
                    </div>
                  </el-upload>

                  <div
                    style="
                      margin: 0 auto;
                      background-color: rgb(17, 18, 37);
                      justify-content: center;
                      position: relative;
                    "
                    :style="{ height: lheight + 'px', width: lwidth + 'px' }"
                    v-show="proofImage"
                  >
                    <canvas
                      v-if="canvasWidth"
                      id="canvas1"
                      :width="canvasWidth"
                      :height="canvasHeight"
                      style="
                        position: absolute;
                        left: 50%;
                        z-index: 99;
                        top: 50%;
                      "
                      :style="{
                        marginLeft: -canvasWidth / 2 + 'px',
                        marginTop: -canvasHeight / 2 + 'px',
                      }"
                    ></canvas>
                    <canvas
                      v-if="canvasWidth"
                      id="canvas2"
                      :width="canvasWidth"
                      :height="canvasHeight"
                      style="
                        position: absolute;
                        left: 50%;
                        z-index: 100;
                        top: 50%;
                      "
                      :style="{
                        marginLeft: -canvasWidth / 2 + 'px',
                        marginTop: -canvasHeight / 2 + 'px',
                      }"
                    ></canvas>

                    <div
                      class="d-flex"
                      @click.stop="deleteProofImage"
                      style="
                        width: 40px;
                        height: 40px;
                        background: rgba(0, 0, 0, 0.5);
                        border-radius: 6px;
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        z-index: 101;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <el-image
                        style="width: 20px; height: 20px; cursor: pointer"
                        :src="require('../assets/img/textform/del.png')"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                    </div>
                  </div>
                </div>

                <el-alert
                  title="该工具不适用于文本类图片处理"
                  type="warning"
                  show-icon
                  style="
                    margin-top: 20px;
                    background-color: #0b2d65;
                    color: #006fff;
                    border: 1px solid #006fff;
                  "
                  class="el_alert"
                >
                </el-alert>

                <!-- <div style="align-items: center; margin-top: 5px">
                  <div
                    class="d-flex"
                    style="align-items: center; margin-top: 20px"
                  >
                    <span style="color: #ef4545">*</span>
                    <div
                      style="
                        min-width: 80px;
                        flex: 1;
                        font-size: 14px;
                        color: rgb(202, 202, 212);
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                      "
                    >
                      倍率选择
                    </div>
                  </div> -->
                 <!--  <div
                    style="
                      padding: 0 0px 0 0px;
                      margin-top: 10px;
                      display: flex;
                      align-items: center;
                      justify-content: flex-start;
                      flex-wrap: wrap;
                    "
                  >
                     --><!-- <span class="batch_size_btn" :class="{ active: scale_factor == 1 }" @click="scale_factor = 1">  <span style="font-weight: 500;font-size: 14px;">1倍高清</span>  <span style="font-size: 12px;color: #CACAD4;">2积分/张</span>   </span>
                    <span class="batch_size_btn" :class="{ active: scale_factor == 2 }" @click="scale_factor = 2">  <span style="font-weight: 500;font-size: 14px;">2倍高清</span>  <span style="font-size: 12px;color: #CACAD4;">2积分/张</span>  </span>
                    <span class="batch_size_btn" :class="{ active: scale_factor == 3 }" @click="scale_factor = 3">  <span style="font-weight: 500;font-size: 14px;">3倍高清</span>  <span style="font-size: 12px;color: #CACAD4;">2积分/张</span> </span>
                    <span class="batch_size_btn" :class="{ active: scale_factor == 4 }" @click="scale_factor = 4">  <span style="font-weight: 500;font-size: 14px;">4倍高清</span>  <span style="font-size: 12px;color: #CACAD4;">2积分/张</span>  </span>
                    <span class="batch_size_btn" :class="{ active: scale_factor == 5 }" @click="scale_factor = 5">  <span style="font-weight: 500;font-size: 14px;">5倍高清</span>  <span style="font-size: 12px;color: #CACAD4;">2积分/张</span>   </span>
                    <span class="batch_size_btn" :class="{ active: scale_factor == 6 }" @click="scale_factor = 6">  <span style="font-weight: 500;font-size: 14px;">6倍高清</span>  <span style="font-size: 12px;color: #CACAD4;">2积分/张</span>  </span>
                    <span class="batch_size_btn" :class="{ active: scale_factor == 7 }" @click="scale_factor = 7">  <span style="font-weight: 500;font-size: 14px;">7倍高清</span>  <span style="font-size: 12px;color: #CACAD4;">2积分/张</span> </span>
                    <span class="batch_size_btn" :class="{ active: scale_factor == 8 }" @click="scale_factor = 8">  <span style="font-weight: 500;font-size: 14px;">8倍高清</span>  <span style="font-size: 12px;color: #CACAD4;">2积分/张</span>  </span> -->

                    <!-- <span
                      class="batch_size_btn"
                      :class="{ active: scale_factor == item }"
                      @click="scale_factor = item"
                      v-for="(item, idx) in 8"
                    >
                      <span style="font-weight: 500; font-size: 14px"
                        >{{ item }}倍高清</span
                      >
                      <span style="font-size: 12px; color: #cacad4">
                        {{
                          Math.round(getBaseLog(item) * 20) + 20
                        }}积分/张</span
                      >
                    </span> -->
                  <!-- </div> -->
                <!-- </div> -->

                <!-- <div style="align-items: center; margin-top: 5px">
                  <div
                    class="d-flex"
                    style="align-items: center; margin-top: 20px"
                  >
                    <span style="color: #ef4545">*</span>
                    <div
                      style="
                        min-width: 80px;
                        flex: 1;
                        font-size: 14px;
                        color: rgb(202, 202, 212);
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                      "
                    >
                      原图类别
                    </div>
                  </div>
                  <div
                    style="
                      padding: 0 0px 0 0px;
                      margin-top: 10px;
                      display: flex;
                      align-items: center;
                      justify-content: flex-start;
                      flex-wrap: wrap;
                    "
                  >
                    <span
                      class="batch_size_btn"
                      :class="{ active: upscaler_index == 'R-ESRGAN 4x+' }"
                      @click="upscaler_index = 'R-ESRGAN 4x+'"
                    >
                      <span style="font-weight: 500; font-size: 14px"
                        >写实照片</span
                      >
                    </span>
                    <span
                      class="batch_size_btn"
                      :class="{
                        active: upscaler_index == 'R-ESRGAN 4x+ Anime6B',
                      }"
                      @click="upscaler_index = 'R-ESRGAN 4x+ Anime6B'"
                    >
                      <span style="font-weight: 500; font-size: 14px"
                        >卡通动漫</span
                      >
                    </span>
                  </div>
                </div> -->

                <div
                  style="
                    margin-top: 14px;
                    position: absolute;
                    bottom: 5px;
                    width: calc(100% - 40px);
                    background-color: rgb(17, 18, 37);
                    padding-top: 10px;
                  "
                  @click.stop="search"
                >
                  <div class="btn-box">
                    立即修复
                    <span
                      style="font-size: 12px; margin-left: 5px"
                      v-if="ac_data.vip"
                      >VIP免积分</span
                    >
                    <span style="font-size: 12px; margin-left: 5px" v-else
                      >(消耗
                      {{ Math.round(getBaseLog(scale_factor) * 20) + 20 }}
                      积分)</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div
              style="width: 50%; padding-left: 9px; overflow-y: auto"
              ref="replace_right"
            >
              <div
                class="replace_left"
                style="
                  background-color: #111225;
                  border-radius: 14px;
                  margin-top: 20px;
                  padding: 20px;
                  box-sizing: border-box;
                  height: calc(100% - 20px);
                  overflow-y: auto;
                  overflow-x: hidden;
                  padding-bottom: 60px;
                "
              >
                <div
                  class="d-flex"
                  style="
                    margin-bottom: 10px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <el-image
                    style="height: 36px; width: 36px; margin-right: 7px"
                    :src="require('../assets/img/qa/result.png')"
                  >
                    <div slot="placeholder" class="image-slot"></div>
                  </el-image>
                  高清修复结果
                </div>

                <div
                  class="tool-main-cont-right d-flex"
                  v-if="imgList.length == 0"
                  :style="{ height: rwidth + 'px', width: rwidth + 'px' }"
                >
                  <div
                    v-if="
                      img_create_loading &&
                      curStatus == 0 &&
                      curObj.index != 0 &&
                      curObj.total != 0
                    "
                    style="margin-top: 35px"
                  >
                    任务排在 {{ curObj.index }}/{{ curObj.total }}
                    队列中，请耐心等待
                    <vue-typed-js
                      style="display: inline-block; min-width: 14px"
                      :strings="['...']"
                      :loop="true"
                      :startDelay="0"
                      :typeSpeed="20"
                      :backSpeed="50"
                      :showCursor="false"
                    >
                      <span class="typing"></span>
                    </vue-typed-js>
                  </div>
                  <div
                    v-if="
                      img_create_loading &&
                      curStatus == 0 &&
                      curObj.index == 0 &&
                      curObj.total == 0
                    "
                    style="margin-top: 35px"
                  >
                    任务即将开始，请耐心等待
                    <vue-typed-js
                      style="display: inline-block; min-width: 14px"
                      :strings="['...']"
                      :loop="true"
                      :startDelay="0"
                      :typeSpeed="20"
                      :backSpeed="50"
                      :showCursor="false"
                    >
                      <span class="typing"></span>
                    </vue-typed-js>
                  </div>
                  <el-progress
                    type="circle"
                    :percentage="
                      curObj.progress - 0
                        ? (curObj.progress * 100).toFixed(0) - 0
                        : 1
                    "
                    text-color="#fff"
                    color="#006FFF"
                    v-if="
                      img_create_loading && curStatus == 1 && curObj.progress
                    "
                  ></el-progress>
                  <div
                    v-if="
                      img_create_loading &&
                      curStatus == 1 &&
                      curObj.progress &&
                      curObj.etaRelative >= 0
                    "
                    style="margin-top: 35px"
                  >
                    <!-- 排队生成中，预计 {{ (curObj.etaRelative).toFixed(0) }} 秒 -->
                    排队生成中，请稍候
                    <vue-typed-js
                      style="display: inline-block; min-width: 14px"
                      :strings="['...']"
                      :loop="true"
                      :startDelay="0"
                      :typeSpeed="20"
                      :backSpeed="50"
                      :showCursor="false"
                    >
                      <span class="typing"></span>
                    </vue-typed-js>
                  </div>
                  <div
                    v-else-if="img_create_loading && curStatus != 0"
                    style="margin-top: 35px"
                  >
                    处理中
                    <vue-typed-js
                      style="display: inline-block; min-width: 14px"
                      :strings="['...']"
                      :loop="true"
                      :startDelay="0"
                      :typeSpeed="20"
                      :backSpeed="50"
                      :showCursor="false"
                    >
                      <span class="typing"></span>
                    </vue-typed-js>
                  </div>
                </div>
                <div
                  v-if="imgList.length > 0"
                  style="text-align: center; position: relative"
                >
                  <div
                    style="
                      position: relative;
                      margin: 0 auto !important;
                      border-radius: 8px;
                    "
                    :style="{ height: rwidth + 'px', width: rwidth + 'px' }"
                    class="exit_hover"
                  >
                    <el-carousel
                      :height="rwidth + 'px'"
                      arrow="never"
                      :autoplay="false"
                      :initial-index="imgIdx"
                      indicator-position="none"
                      ref="cardShow"
                      class="images_"
                      v-viewer="{
                        movable: true,
                        navbar: false,
                        toolbar: true,
                        title: false,
                        fullscreen: false,
                        rotatable: false,
                        scalable: false,
                      }"
                    >
                      <el-carousel-item
                        v-for="(item, idx) in imgList"
                        :key="idx"
                      >
                        <el-image
                          :src="item.image"
                          class="avatar"
                          fit="contain"
                          style="margin-left: 5px"
                          :style="{
                            width: rwidth + 'px',
                            height: rwidth + 'px',
                          }"
                          v-if="item.image"
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <el-image
                          :fit="'contain'"
                          :style="{
                            height: rwidth + 'px',
                            width: rwidth + 'px',
                          }"
                          style="margin: 0 auto !important; border-radius: 8px"
                          :src="require('../assets/img/textform/forbid.png')"
                          v-else
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-carousel-item>
                    </el-carousel>

                    <el-tooltip
                      popper-class="tps"
                      class="item"
                      effect="dark"
                      :enterable="false"
                      content="下载"
                      placement="right"
                      :close-delay="10"
                    >
                      <el-image
                        style="
                          width: 36px;
                          height: 36px;
                          position: absolute;
                          right: -0px;
                          bottom: -60px;
                          cursor: pointer;
                        "
                        :src="require('../assets/img/textform/download.png')"
                        fit="contain"
                        @click="downloadImage"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                    </el-tooltip>

                    <el-tooltip
                      popper-class="tps"
                      class="item"
                      effect="dark"
                      :enterable="false"
                      content="分享"
                      placement="right"
                      :close-delay="10"
                    >
                      <el-image
                        style="
                          width: 36px;
                          height: 36px;
                          position: absolute;
                          right: 54px;
                          bottom: -60px;
                          cursor: pointer;
                        "
                        :src="require('../assets/img/textform/share.png')"
                        fit="contain"
                        @click="shareImg"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                    </el-tooltip>

                    <div
                      @click="carouselClick"
                      style="
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        cursor: pointer;
                        justify-content: center;
                        align-items: center;
                        width: 40px;
                        height: 40px;
                        background: rgba(0, 0, 0, 0.5);
                        border-radius: 6px;
                        z-index: 9;
                      "
                      class="d-flex"
                    >
                      <el-image
                        style="width: 20px; height: 20px"
                        :src="require('../assets/img/textform/fullscreen.png')"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-main>

          <el-aside width="300px" class="history">
            <el-tabs v-model="activeName2" style="height: 100%">
              <el-tab-pane
                label="我的照片"
                name="我的照片"
                style="height: 100%"
              >
                <span slot="label">
                  <div class="title t2"><span>我的照片</span></div>
                </span>
                <div
                  class="scroll-cont"
                  style="
                    scrollbar-width: none;
                    overflow-y: auto;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #828292;
                    box-sizing: border-box;
                  "
                >
                  <div
                    v-if="his_list.length == 0"
                    style="
                      color: gray;
                      text-align: center;
                      margin-top: 8px;
                      font-size: 16px;
                    "
                  >
                    暂无数据
                  </div>
                  <vue-loadmore
                    :on-refresh="onRefresh"
                    :on-loadmore="onLoad"
                    :finished="finished"
                    :finished-text="' '"
                    class="his_item_container"
                  >
                    <div
                      v-for="(item, i) in his_list"
                      :key="i"
                      class="his-item"
                      style="display: inline-block; position: relative"
                      @click="his_item_click(item.list)"
                      v-on:mouseover="handleMouseOver(i)"
                      v-on:mouseout="handleMouseOut(i)"
                    >
                      <el-image
                        class="deleteIcon"
                        style="
                          width: 16px;
                          height: 16px;
                          cursor: pointer;
                          position: absolute;
                          top: 8px;
                          right: 8px;
                          z-index: 11;
                        "
                        :src="require('../assets/img/textform/delete.png')"
                        fit="contain"
                        @click.stop="deleteHis(i)"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      <div class="top_model"></div>
                      <div
                        class="d-flex"
                        style="flex-wrap: wrap; justify-content: flex-start"
                      >
                        <template v-for="imgitem in item.list">
                          <el-image
                            style="margin: 0; cursor: pointer"
                            :src="imgitem.image"
                            fit="contain"
                            :class="{
                              imgB1: item.list.length == 1,
                              imgB2: item.list.length == 2,
                              imgB3: item.list.length == 3,
                              imgB4: item.list.length == 4,
                            }"
                            :fit="'cover'"
                            v-if="imgitem.image"
                          >
                            <div slot="placeholder" class="image-slot"></div>
                          </el-image>
                          <el-image
                            style="margin: 0; cursor: pointer"
                            :src="require('../assets/img/textform/forbid.png')"
                            fit="contain"
                            :class="{
                              imgB1: item.list.length == 1,
                              imgB2: item.list.length == 2,
                              imgB3: item.list.length == 3,
                              imgB4: item.list.length == 4,
                            }"
                            :fit="'cover'"
                            v-else
                          >
                            <div slot="placeholder" class="image-slot"></div>
                          </el-image>
                        </template>
                      </div>
                    </div>
                  </vue-loadmore>
                </div>
              </el-tab-pane>
            </el-tabs>
            <!-- -->
          </el-aside>
        </el-container>
      </el-main>
    </el-container>

    <LoginForm
      :dialogLoginVisible.sync="loginFormShow"
      v-if="loginFormShow"
    ></LoginForm>
    <NewRecharge
      :newRechargeShow.sync="newRechargeShow"
      v-if="newRechargeShow"
      @gotoRecharge="gotoRecharge"
    ></NewRecharge>
    <CompareAlert
      :CompareAlertShow.sync="compareAlertShow"
      v-if="compareAlertShow"
      :alertnum="5"
    ></CompareAlert>

    <ShareCont
      :dialogShareVisible.sync="shareShow"
      :shareValue="shareValue"
      :imgUrl="
        imgList && imgList[imgIdx] && imgList[imgIdx].image
          ? imgList[imgIdx].image
          : ''
      "
      :shareImgMd5="shareImgMd5"
    >
    </ShareCont>
    <Status></Status>
  </el-container>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarLeft from "@/components/NavbarLeft.vue";
import {
  te_op_req,
  te_page_req,
  te_del,
  chat_page_req,
  chat_add_req,
  chat_del_req,
  chat_sensitiveKeywords_req,
  chat_push_req,
} from "@/api/qa";
import {
  copyToClip,
  parseTime,
  getToken,
  getSocketUrl,
  getUUID,
} from "@/utils/bose";
import { user_account_req, event_log_req } from "@/api/user";

import {
  imgtemplate_list_req,
  add_task_req,
  add_imgrepair_req,
} from "@/api/replaceface";
import {
  img_page_req,
  task_interrupt_req,
  task_status_req,
  task_running_req,
  task_undoTask_req,
  img_del,
  painting_removeByTid,
} from "@/api/taskImage";
import { painting_download_req } from "@/api/square";
import {
  painting_page_req,
  painting_publish_req,
  painting_history_req,
  painting_cancel_req,
} from "@/api/personal";
import { growth_tasks_req, growth_publish_req } from "@/api/task";

import { Loading } from "element-ui";
import md5 from "js-md5";
import Status from "@/components/Status";
import LoginForm from "@/components/LoginForm";
import ShareCont from "@/components/ShareCont";
import NewRecharge from "@/components/NewRecharge";
import CompareAlert from "@/components/CompareAlert";

export default {
  components: {
    Status,
    Navbar,
    NavbarLeft,
    LoginForm,
    ShareCont,
    NewRecharge,
    CompareAlert,
  },
  data() {
    return {
      ac_data: {}, //账户信息
      needUpdate: 1,
      needRecharge: 0,
      loginFormShow: false,
      lwidth: 0,
      lheight: 0,
      rwidth: 0,
      rheight: 0,
      proofImage: undefined,
      canvasWidth: 0,
      canvasHeight: 0,
      activeName: "女生",
      activeName2: "我的照片",
      templatelist1: [],
      templatelist2: [],
      templatelist3: [],

      isHover: false,
      hoverIdx: undefined,
      selectedidx: 0,
      img_create_loading: false,
      curStatus: undefined,
      curObj: undefined,
      imgList: [],
      imgIdx: 0,
      formVuex: {
        batch_size: 1,
      },
      curTask: undefined,
      timer: null,
      progress_value: 0,
      needSec: undefined,
      needSecStep: undefined,
      isQuery: undefined, //是否进行了查询
      shareShow: false, //分享模块是否展示
      shareValue: undefined,
      shareImgMd5: undefined,
      // 下拉滚动相关
      pageNum: 1,
      pageSize: 20,
      his_list: [],
      finished: false,
      // 下拉滚动相关
      newRechargeShow: false, //新用户充值
      needRecharge: 0,

      scale_factor: 1,
      upscaler_index: "R-ESRGAN 4x+",
      compareAlertShow: false,
    };
  },
  mounted() {
    if (!localStorage.getItem("HDrestoration")) {
      this.compareAlertShow = true;
    }
    if (localStorage.getItem("restorationPaerams")) {
      let params = JSON.parse(localStorage.getItem("restorationPaerams"));
      this.proofImage = params.proofImage;
      this.upscaler_index = params.upscaler_index;
      this.scale_factor = params.scale_factor;
    }
    if (this.$refs.replace_left && this.$refs.replace_left.offsetWidth) {
      console.log(this.$refs.replace_left.offsetWidth);
      let _width = this.$refs.replace_left.offsetWidth - 40;
      this.lwidth = _width ? _width : 200;
      this.lheight = _width / 2.43 ? _width / 2.43 : 200;
      this.rwidth = _width ? _width - 130 : 200;
      this.rheight = _width ? _width - 130 : 200;
    }
    this.img_page_get();
    this.getUserAccountInfo();
  },
  beforeDestroy() {
    if (localStorage.getItem("taskIds")) {
      task_status_req(localStorage.getItem("taskIds")).then((res) => {
        if (
          res.data.status >= 2 &&
          localStorage.getItem("restorationPaerams")
        ) {
          localStorage.removeItem("taskIds");
          localStorage.removeItem("restorationPaerams");
        }
      });
    }
  },
  methods: {
    btoaFunc(val) {
      return window.btoa(val);
    },
    deleteHis(i) {
      if (this.img_create_loading) {
        return;
      }
      let taskId = this.his_list[i].taskId;

      this.$confirm("", "删除此条记录，您的作品也将一并删除，是否删除?", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        center: true,
        customClass: "_message_box2",
      })
        .then(({ value }) => {
          painting_removeByTid(taskId).then((res) => {
            this.$toast.open({
              message: "已删除",
              position: "top",
              duration: 3000,
              type: "success",
            });

            try {
              if (
                this.his_list[i].list[0].md5 &&
                this.imgList[0].md5 &&
                this.his_list[i].list[0].md5 == this.imgList[0].md5
              ) {
                this.imgList = [];
              }
            } catch (error) {
              console.error(error);
            }
            this.his_list.splice(i, 1);
          });
        })
        .catch(() => {
          // this.$toast.open({
          //     message: '删除失败，请稍后再试',
          //     position: 'top',
          //     duration: 1000,
          //     type: 'error',
          //   });
        });
    },
    checkLogin() {
      return false;
    },
    getFile(file, fileList, scope) {
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        return;
      }
      let imgSize = Number(file.size / 1024 / 1024);
      if (imgSize > 5) {
        this.$toast.open({
          message: "图片最大5MB哦，请重试",
          position: "top",
          duration: 3000,
          type: "error",
        });
        return;
      }
      if (fileList && fileList.length >= 2) {
        fileList.shift();
      }
      this.proofImage = undefined;
      this.getBase64(file.raw).then((res) => {
        const params = res.split(",");
        if (params.length > 0) {
          this.proofImage = params[1];
        }
      });
    },
    // 获取图片转base64
    getBase64(file) {
      let _this = this;
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          imgResult = reader.result;
          const img = e.target.result;
          const image = new Image();
          image.src = img;
          image.onload = (_) => {
            console.log(image.width);

            let width = image.width;
            let height = image.height;
            _this.formVuex.width = width;
            _this.formVuex.height = height;
            /* if (width >= 2000 || height >= 2000) {
              if (width >= height) {
                let bili = width / height;
                width = 2000;
                height = Math.floor(2000 / bili);
              } else {
                let bili = height / width;
                height = 2000;
                width = Math.floor(2000 / bili);
              }
              _this.formVuex.width = width;
              _this.formVuex.height = height;
            } else {
              _this.formVuex.width = width;
              _this.formVuex.height = height;
            } */
          };
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    deleteProofImage() {
      this.proofImage = undefined;
    },
    getImgtemplateList(type) {
      imgtemplate_list_req({
        type: type,
      }).then((res) => {
        if (type == "女生") {
          this.templatelist1 = res.data;
        } else if (type == "男生") {
          this.templatelist2 = res.data;
        } else if (type == "儿童") {
          this.templatelist3 = res.data;
        }
      });
    },

    handleMouseOver(index) {
      this.isHover = true;
      this.hoverIdx = index;
    },
    handleMouseOut() {
      this.isHover = false;
      this.hoverIdx = undefined;
    },
    async search() {
      if (this.img_create_loading) {
        return;
      }
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        return;
      }

      if (!this.proofImage) {
        this.$toast.open({
          message: "请先选择照片哦",
          position: "top",
          duration: 3000,
          type: "error",
        });
        return;
      }
      if(this.formVuex.width < 50 || this.formVuex.width > 2128){
        this.$toast.open({
          message: "宽必须在[50,2128]范围内",
          position: "top",
          duration: 3000,
          type: "error",
        });
        return;
      }
      if(this.formVuex.height < 50 || this.formVuex.height > 4046){
        this.$toast.open({
          message: "长必须在[50,4046]范围内",
          position: "top",
          duration: 3000,
          type: "error",
        });
        return;
      }
      this.imgList = [];

      this.img_create_loading = true;
      this.formVuex.init_images = [this.proofImage];
      //this.formVuex.upscaler_index = this.upscaler_index;
      //this.formVuex.scale_factor = this.scale_factor;
      let params = JSON.parse(JSON.stringify(this.formVuex));
      
      let restorationPaerams = {
        proofImage: this.proofImage,
        upscaler_index: this.upscaler_index,
        scale_factor: this.scale_factor,
      };
      localStorage.setItem(
        "restorationPaerams",
        JSON.stringify(restorationPaerams)
      );
     /*  let testSize = false;
      if (
        params.scale_factor * params.width > 2048 ||
        params.scale_factor * params.height > 2048
      ) {
        testSize = true;
      }
      if (testSize) {
        this.$toast.open({
          message: "放大后分辨率超过限制，请减小放大倍率",
          position: "top",
          duration: 3000,
          type: "error",
        });
        this.img_create_loading = false;
        return;
      } */

      await add_imgrepair_req(params).then((res) => {
        const { data, success } = res;
        if (data && success) {
          this.curTask = data;
          localStorage.setItem("taskId", data);
          localStorage.setItem("taskIds", data);
          localStorage.setItem("link", "/HDrestoration");
          if (this.timer) clearInterval(this.timer);
          this.startTaskStatus();
        } else {
          this.curTask = undefined;
          this.img_create_loading = false;
          this.progress_value = 0;
          this.needSec = undefined;
          this.needSecStep = undefined;
          this.imgList = [];
        }
      });
    },
    startTaskStatus() {
      this.timer = setInterval(() => {
        if (this.isQuery == true) return;
        this.isQuery = true;
        task_status_req(this.curTask)
          .then((statusres) => {
            this.curStatus = statusres.data.status;
            if (this.curStatus == 0) {
              this.curObj = statusres.data.obj;
              // console.log(statusres)
            } else if (this.curStatus == 1) {
              // console.log(statusres)
              this.curObj = statusres.data.obj;
            } else if (this.curStatus == 2) {
              clearInterval(this.timer);
              // this.$refs.theupload.clearFiles()

              this.curTask = undefined;
              this.img_create_loading = false;
              this.curObj = statusres.data.obj;
              this.imgList = statusres.data.obj.list;
              this.pageNum = 1;
              this.finished = false;
              this.his_list = [];
              this.img_page_get({
                refresh: true,
              });

              if (this.hasFrom) {
                growth_tasks_req({ type: 5 }).then((res1) => {
                  if (res1.data[0].total >= res1.data[0].count) {
                    setTimeout(() => {
                      this.$toast.open({
                        message: "应用成功，2积分已到账",
                        position: "top",
                        duration: 3000,
                        type: "success",
                      });
                    }, 1000);
                  }
                });
              }
            } else if (this.curStatus == 3) {
              clearInterval(this.timer);
              this.curTask = undefined;
              this.img_create_loading = false;
              this.curObj = undefined;
              this.imgList = [];
              this.curStatus = undefined;
              this.$toast.open({
                message: statusres.data.obj,
                position: "top",
                duration: 3000,
                type: "error",
              });
            } else if (this.curStatus == 5) {
              clearInterval(this.timer);
              this.curTask = undefined;
              this.img_create_loading = false;
              this.curObj = undefined;
              this.imgList = [];
              this.curStatus = undefined;
              this.$toast.open({
                message: statusres.data.obj,
                position: "top",
                duration: 3000,
                type: "success",
              });
            }
          })
          .catch((err) => {
            clearInterval(this.timer);
          })
          .finally((res) => {
            this.isQuery = false;
            this.getUserAccountInfo(); //获取账户信息
          });
      }, 1000);
    },
    carouselClick() {
      // this.carouselShow = true ;
      // this.dialogImgArr = this.imgList
      const viewer = this.$el.querySelector(".images_").$viewer;
      //调用show方法进行显示预览图
      viewer.show();
    },
    async getUserAccountInfo() {
      const { data, success } = await user_account_req();
      if (success) {
        this.ac_data = data;
        setTimeout(() => {
          var todaysDate = new Date();
          if (localStorage.getItem("hasRecharge")) {
          } else {
            if (localStorage.getItem("rechargeShowDate")) {
              //如果有
              if (
                localStorage.getItem("rechargeShowDate") ==
                todaysDate.setHours(0, 0, 0, 0)
              ) {
                //弹过了
              } else {
                localStorage.setItem(
                  "rechargeShowDate",
                  todaysDate.setHours(0, 0, 0, 0)
                );
                this.newRechargeShow = true;
              }
            } else {
              localStorage.setItem(
                "rechargeShowDate",
                todaysDate.setHours(0, 0, 0, 0)
              );
              this.newRechargeShow = true;
            }
          }
        }, 1000);
      }
    },
    downloadImage() {
      if (this.imgList[this.imgIdx].image === null) {
        this.$toast.open({
          message: "违规图片无法下载",
          position: "top",
          duration: 3000,
          type: "default",
        });
        return;
      }

      painting_download_req({
        imgMd5: this.imgList[this.imgIdx].md5,
        isMask: false,
      }).then((res) => {
        const image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.src = res.data;
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0, image.width, image.height);
          const url = canvas.toDataURL("image/png");
          const a = document.createElement("a");
          a.href = url;
          a.download = "image.png";
          a.click();
        };
      });

      return;

      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.src = this.imgList[this.imgIdx].image;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = url;
        a.download = "image.png";
        a.click();
      };
    },
    shareImg() {
      if (this.imgList[this.imgIdx].image === null) {
        this.$toast.open({
          message: "违规图片无法分享",
          position: "top",
          duration: 3000,
          type: "default",
        });
        return;
      }
      this.$prompt("", "分享图展示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "输入标题会更受欢迎哦（可选）",
        inputErrorMessage: "标题最多20字哦",
        inputPattern: /^(a-z|A-Z|0-9)*[^$%^&*;:,<>?()\""\']{0,20}$/,
        center: true,
        customClass: "_message_box",
      })
        .then(({ value }) => {
          this.shareValue = value ? value : "";
          this.shareImgMd5 = this.imgList[this.imgIdx].md5;
          this.shareShow = true;
          growth_publish_req({ type: 4 }).then(() => {
            growth_tasks_req({ type: 4 }).then((res1) => {
              if (res1.data[0].total >= res1.data[0].count) {
                setTimeout(() => {
                  this.$toast.open({
                    message: "分享成功，2积分已到账",
                    position: "top",
                    duration: 3000,
                    type: "success",
                  });
                }, 1000);
              }
            });
          });
        })
        .catch(() => {});

      //this.shareShow = true ;
    },
    compareImg() {},

    // 历史记录相关 //
    onRefresh(done) {
      this.his_list = [];
      this.pageNum = 1;
      this.finished = false;
      this.img_page_get();
      done();
    },
    onLoad(done) {
      this.img_page_get();
      done();
    },
    // 获取历史记录
    img_page_get(params) {
      if (!this.tokenVuex) {
        return;
      }
      painting_history_req({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        category: 7,
        orderType: 1,
      }).then((res) => {
        if (res.success) {
          if (params && params.refresh == true) this.his_list = [];
          if (this.pageNum == 1 && this.$route.query?.type === "echo") {
            this.his_item_click(res.data.records[0].list);
          }
          this.his_list = this.his_list.concat(res.data.records);
          if (this.pageNum >= res.data.pages) {
            this.finished = true;
            return;
          }
          this.pageNum++;
        } else {
          this.his_list = [];
          this.pageNum = 1;
        }
      });
    },
    his_item_click(list) {
      this.imgList = list;
      this.imgIdx = 0;
    },
    gotoRecharge() {
      this.newRechargeShow = false;
      this.needRecharge++;
    },
    getBaseLog(y) {
      return Math.log(y) / Math.log(4);
    },
  },
  computed: {
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token;
    },
  },
  watch: {
    proofImage(newQuestion, oldQuestion) {
      let _this = this;
      var image = new Image();
      image.src = "data:image/png;base64," + newQuestion;
      let size = this.lheight;

      image.onload = function () {
        if (this.width / 2.43 >= this.height) {
          // 宽 > 高
          let bili = (this.width / this.height).toFixed(2); //1.5
          _this.canvasWidth = size * 2.43;
          _this.canvasHeight = size.toFixed(0);
        } else {
          let bili = (this.height / this.width).toFixed(2); //1.5
          _this.canvasHeight = size;
          _this.canvasWidth = (size / bili).toFixed(0);
        }

        _this.$nextTick(() => {
          var flag = false; // 记录鼠标按下和抬起事件，标记工具是否开始工作
          var canvas1 = document.getElementById("canvas1");
          var canvas2 = document.getElementById("canvas2");

          var ctx1 = canvas1.getContext("2d");
          var ctx2 = canvas2.getContext("2d");
          if (this.width >= this.height) {
            // 宽 > 高
            let bili = (this.width / this.height).toFixed(2); //1.5
            ctx1.drawImage(image, 0, 0, _this.canvasWidth, _this.canvasHeight);
            // ctx2.drawImage(image, 0, 0 , _this.canvasWidth , _this.canvasHeight  );
          } else {
            // 高 > 宽
            let bili = (this.height / this.width).toFixed(2); //1.5
            // ctx2.drawImage(image, (size - (size/bili).toFixed(0)) / 2 , 0 , (size/bili).toFixed(0)  , size  );
            ctx1.drawImage(image, 0, 0, _this.canvasWidth, _this.canvasHeight);
            // ctx2.drawImage( image ,  0, 0 ,  _this.canvasWidth , _this.canvasHeight );
          }
        });
      };
    },
    activeName() {
      this.selectedidx = 0;
    },
    tokenVuex(newQuestion, oldQuestion) {
      // console.log( newQuestion  )
      if (!newQuestion) {
        this.$router.replace({
          name: "home", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
          params: {
            unlogin: true,
          },
        });
      } else {
        let _this = this;
        this.img_page_get();
        this.getUserAccountInfo(); //获取账户信息
        this.getTaskRunning();
      }
    },
    compareAlertShow(newVal) {
      if (!newVal) {
        localStorage.setItem("HDrestoration", "popup");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .main_cont {
  height: calc(100vh - 66px);
}
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}
::v-deep .el-tabs__item {
  color: #cacad4;
  font-weight: 400;
  padding: 0;
  width: 70px;
}
::v-deep .el-tabs__item.is-active {
  color: #fff;
  font-weight: 500;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #111225;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #111225;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

::v-deep .el-tabs__item.is-active .title:after {
  content: "";
  display: block;
  width: 20px;
  height: 4px;
  background: #006fff;
  border-radius: 2px;
  position: absolute;
  bottom: 2px;
}

::v-deep .el-tabs__active-bar {
  background-color: transparent !important;
}

::v-deep .el-tabs__item.is-active .t1:after {
  left: 4px;
}

::v-deep .el-tabs__item.is-active .t2:after {
  left: 4px;
}
::v-deep .el-tabs__item.is-active .t3:after {
  left: 4px;
}

::v-deep .el-tabs__header.is-top {
  margin-bottom: 11px;
}
::v-deep .el_alert .el-alert__title {
  color: #ffffff;
}

.img_cont1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  // background-color: #006FFF;
  background-image: url("../assets/img/replaceface/bg1.png");
  background-size: 100%;
  flex-direction: column;
}

::v-deep .main_cont {
  height: calc(100vh - 66px);

  .el-upload-dragger {
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent !important;
  }

  .upload-file .el-upload-list .el-upload-list__item:hover .el-icon-close {
    display: none;
  }
}

.template_cont {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  .item {
    width: 31%;
    // height: 0;
    // padding-bottom : 25% ;
    border-radius: 8px;
    margin-right: 9px;
    margin-bottom: 14px;
    border-radius: 8px;
    img {
      border-radius: 8px;
      width: calc(100% - 4px);
      height: calc(100%);
    }
  }
  .item:nth-child(3n + 3) {
    color: #ccc;
    margin-right: 0px;
  }
  .item:hover img {
    transform: scale(1.05);
    transition: all 0.5s;
    border-radius: 8px;
    border: 2px solid #006fff;
  }
  .item:hover {
    border: none !important;
  }
  .item.selected {
    border: 2px solid #006fff;
  }
}

.batch_size_btn {
  width: 144px;
  height: 40px;
  line-height: 40px;
  background: rgb(37, 39, 57);
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  display: block;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 10px;
  color: #cacad4;
}
.batch_size_btn.active {
  background: #006fff;
  color: #fff;
  line-height: 40px;
}

.tool-main-cont-right {
  justify-content: center;
  align-items: center;
  // height: 450px;
  // width: 450px;
  margin: 0 auto;
  // background-color: #006FFF;
  background-image: url("../assets/img/replaceface/bg2.png");
  background-size: 100%;
  flex-direction: column;
}

.history {
  text-align: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  background: #111225;

  .title {
    box-sizing: border-box;
    padding: 0 15px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    position: relative;
  }

  ::v-deep .el-tabs__item.is-active .title:after {
    content: "";
    display: block;
    width: 20px;
    height: 4px;
    background: #006fff;
    border-radius: 2px;
    position: absolute;
    bottom: 2px;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: transparent !important;
  }

  ::v-deep .el-tabs__item.is-active .t1:after {
    left: 30px;
  }

  ::v-deep .el-tabs__item.is-active .t2:after {
    left: 37px;
  }

  ::v-deep .el-tabs__header.is-top {
    margin-bottom: 11px;
  }

  .scroll-cont {
    height: calc(100% - 25px);
    position: relative;
  }

  .scroll-cont {
    overflow: hidden;
  }

  .scroll-cont::-webkit-scrollbar {
    width: 5px;
    display: flex;
  }

  .scroll-cont::-webkit-scrollbar-thumb {
  }

  .scroll-cont:hover {
    overflow-y: auto;
    // width: calc(100% - 1px )
  }

  .his-item {
    box-sizing: border-box;
    border-radius: 5px;
    flex-wrap: wrap;
    width: 130px;
    height: 130px;
    margin-bottom: 5px;
    align-content: stretch;
    position: relative;
    overflow: hidden;

    .imgB1 {
      width: 130px;
      height: 130px;
    }

    .imgB2 {
      width: 65px;
      height: 130px;
    }

    .imgB3 {
      width: 65px;
      height: 65px;
    }

    .imgB4 {
      width: 65px;
      height: 65px;
    }

    img {
      width: 50%;
      height: 50%;
    }
    .top_model {
      position: absolute;
      top: 0;
      width: 100%;
      left: 0;
      right: 0;
      height: 34px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.7) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      z-index: 10;
      display: none;
    }
    .deleteIcon {
      display: none;
    }
  }

  .his-item:nth-child(2n + 2) {
    margin-right: 10px;
  }

  .his-item:hover {
    .top_model {
      display: block;
    }
    .deleteIcon {
      display: block;
    }
  }
}

/*修改.el-progress背景色*/
::v-deep .el-progress-circle__track {
  stroke: #38394b;
}
</style>
